import classNames from 'classnames';

export type CommonSkeltonLoaderTypes =
  | 'common'
  | 'media'
  | 'textarea'
  | 'common-sm'
  | 'common-md'
  | 'common-lg'
  | 'dropdown'
  | 'media-md'
  | 'tag'
  | 'text'
  | 'heading'
  | 'paragraph'
  | 'sentence'
  | 'select';

type CommonSkeltonLoadersProps = {
  type: CommonSkeltonLoaderTypes;
  customClassName?: string;
};
const CommonSkeltonLoaders = (props: CommonSkeltonLoadersProps) => {
  const { type, customClassName = '' } = props;
  const renderContent = () => {
    switch (type) {
      case 'common':
        return <div data-testid="common-loader" className={`common-loading ${customClassName}`} />;
      case 'media-md':
        return (
          <div data-testid="media-loader" className={`dummy-space has-md ${customClassName}`}>
            <div className="common-loading--upload-md" />
            <div className="common-loading--upload-md" />
            <div className="common-loading--upload-md" />
          </div>
        );

      case 'media':
        return (
          <div data-testid="media-loader" className={`dummy-space ${customClassName}`}>
            <div className="common-loading--upload" />
            <div className="common-loading--upload" />
            <div className="common-loading--upload" />
          </div>
        );
      case 'common-lg':
        return (
          <div data-testid="common-lg-loader" className={`common-loading--lg ${customClassName}`} />
        );
      case 'common-md':
        return (
          <div data-testid="common-md-loader" className={`common-loading--md ${customClassName}`} />
        );
      case 'common-sm':
        return <div className={`common-loading--sm ${customClassName}`} />;
      case 'dropdown':
        return (
          <div
            data-testid="dropdown-loader"
            className={`common-loading--textarea ${customClassName}`}
          />
        );
      case 'paragraph':
        return (
          <div className={`dummy-space has-md ${customClassName}`}>
            <div className="common-loading--text" />
            <div className="common-loading--text" />
            <div className="common-loading--text w-40" />
          </div>
        );
      case 'sentence':
        return (
          <div className={`dummy-space has-md ${customClassName}`}>
            <div className="common-loading--text" />
            <div className="common-loading--text w-40" />
          </div>
        );
      case 'heading':
      case 'tag':
      case 'text':
      case 'textarea':
      case 'select':
        return (
          <div
            className={classNames(customClassName, `common-loading--${type}`)}
            data-testid={`common-loading--${type}`}
          />
        );
      default:
        return <div data-testid="common-loader" className={`common-loading ${customClassName}`} />;
    }
  };

  return <>{renderContent()}</>;
};

export default CommonSkeltonLoaders;
